import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Toast } from './../UI/toast/Toast'
import { createProvider } from '../../helpers/api/provider'
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes'
import handleErrorMessage from '../../helpers/errors/handleErrorMessage'
import withRedirect from '../../helpers/hoc/withRedirect'
import PageHeader from '../common/PageHeader'
import CreateProviderForm from './CreateProviderForm'
import SupportLink from '../root/support/components/SupportLink'

const CreateProvider = ({ setRedirectUrl, setRedirect }) => {

    const { selectedCondominium, condominium } = useSelector(state => state.condominium);

    const handleSubmitData = async (values) => {
        try {
            const response = await createProvider(selectedCondominium, values);
            if (response.code === SUCCESS_RESPONSE.CREATED) {
                Toast.fire({
                    type: 'success',
                    title: 'Se ha creado el proveedor satisfactoriamente.',
                });
                setRedirect(true);
                setRedirectUrl('/dashboard/providers');
            }
        } catch (error) { handleErrorMessage(error); }
    }

    useEffect(() => {
        setRedirectUrl(`/dashboard/providers`);
    }, [setRedirectUrl]);

    return  <>
                <PageHeader
                    title={`Crear nuevo proveedor para el condominio ${condominium ? condominium : ''}`}
                    titleTag="h2"
                    description="Crea un nuevo proveedor y gestionalo al instante."
                    className="mb-3"
                    col={{ lg: 9 }}
                >
                    <SupportLink />
                </PageHeader>
                <CreateProviderForm condominiumId={selectedCondominium} handleSubmitData={handleSubmitData} setRedirect={setRedirect} setRedirectUrl={setRedirectUrl} />
            </>
}

export default withRedirect(CreateProvider);